export const responseFilter = (data: any) => {
  // data = JSON.parse(data.body.Data);
  return data.body;
}
